// JS Entry file
console.log('loaded')

// Scroll state management
;(function () {
  const body = document.body
  let lastScrollY = window.scrollY
  let ticking = false

  function updateScrollState() {
    const currentScrollY = window.scrollY

    if (currentScrollY > 100) {
      body.classList.add('scrolled')

      if (currentScrollY > lastScrollY) {
        body.classList.add('scrolled--down')
        body.classList.remove('scrolled--up')
      } else {
        body.classList.add('scrolled--up')
        body.classList.remove('scrolled--down')
      }
    } else {
      body.classList.remove('scrolled', 'scrolled--down', 'scrolled--up')
    }

    lastScrollY = currentScrollY
    ticking = false
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(updateScrollState)
      ticking = true
    }
  })
})()

// Homepage scroll reveal - inner section elements rise + fade in once on scroll
;(function () {
  const sections = document.querySelectorAll('.js-reveal')
  if (!sections.length) return

  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches

  // No-JS already handled (hidden state needs .reveal-ready). For reduced
  // motion or no IntersectionObserver support, just show everything.
  if (reduceMotion || !('IntersectionObserver' in window)) {
    sections.forEach(function (el) {
      el.classList.add('is-visible')
    })
    return
  }

  document.body.classList.add('reveal-ready')

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible')
          observer.unobserve(entry.target)
        }
      })
    },
    { threshold: 0, rootMargin: '0px 0px -10% 0px' }
  )

  // The reveal motion is a CSS @keyframes animation (see _home-reveal.scss), so
  // it plays even when a section is already in view on load - e.g. after
  // refreshing mid-page - which a transition would skip.
  sections.forEach(function (el) {
    observer.observe(el)
  })
})()

// Dealer map dots - reveal in a random order once the section is well into view
;(function () {
  const maps = document.querySelectorAll('.promo-banner__map')
  if (!maps.length) return

  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches

  // Reduced motion / no IntersectionObserver: leave the dots visible (the
  // hidden state only applies once `.reveal-ready` is on the body).
  if (reduceMotion || !('IntersectionObserver' in window)) return

  document.body.classList.add('reveal-ready')

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed')
          observer.unobserve(entry.target)
        }
      })
    },
    // Wait until half the map is on screen before the dots start popping in.
    { threshold: 0.5 }
  )

  maps.forEach(function (el) {
    observer.observe(el)
  })
})()

// About page hero - scroll-driven logotype reveal
// While the pinned stage scrolls past, the logotype mask grows and the black
// overlay fades out, so the media behind is revealed full-bleed.
;(function () {
  const hero = document.querySelector('[data-about-hero]')
  if (!hero) return

  const stage = hero.querySelector('.about-hero__stage')
  if (!stage) return

  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches

  if (reduceMotion) {
    hero.style.setProperty('--about-hero-media-scale', '1')
    return
  }

  // How far the logotype grows, as a share of the stage width. Big enough that
  // the letterforms are off-screen well before the overlay finishes fading.
  const END_SIZE = 2400
  // The overlay is solid until the zoom is this far along, then fades out.
  const FADE_START = 0.65

  let ticking = false

  function update() {
    const distance = hero.offsetHeight - stage.offsetHeight
    const travelled = -hero.getBoundingClientRect().top
    let progress = distance > 0 ? travelled / distance : 0
    progress = Math.min(1, Math.max(0, progress))

    const startSize =
      parseFloat(
        getComputedStyle(hero).getPropertyValue('--about-hero-logo-start')
      ) || 84

    // Squared easing: slow at first, then the zoom takes off.
    const eased = progress * progress
    const fade = Math.min(
      1,
      Math.max(0, (1 - progress) / (1 - FADE_START))
    )

    hero.style.setProperty(
      '--about-hero-logo-size',
      startSize + eased * (END_SIZE - startSize) + '%'
    )
    hero.style.setProperty('--about-hero-fade', String(fade))
    hero.style.setProperty(
      '--about-hero-media-scale',
      String(1.12 - 0.12 * progress)
    )

    ticking = false
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update)
      ticking = true
    }
  }

  update()
  window.addEventListener('scroll', onScroll, { passive: true })
  window.addEventListener('resize', onScroll)
})()

// Number counters - count up from zero once they scroll into view
;(function () {
  const counters = document.querySelectorAll('[data-counter]')
  if (!counters.length) return

  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches

  // Without an observer (or with reduced motion) the final value is already in
  // the markup, so there is nothing to do.
  if (reduceMotion || !('IntersectionObserver' in window)) return

  const DURATION = 1600

  function animate(el) {
    const raw = el.dataset.counter || el.textContent
    const match = raw.match(/\d[\d\s.,]*\d|\d/)
    if (!match) return

    const numeric = match[0]
    const target = parseInt(numeric.replace(/\D/g, ''), 10)
    if (!isFinite(target)) return

    // "20 000" keeps its thousands grouping while counting up.
    const grouped = /\s/.test(numeric)
    const prefix = raw.slice(0, match.index)
    const suffix = raw.slice(match.index + numeric.length)
    let start = null

    function format(value) {
      let text = String(value)
      if (grouped) {
        text = text.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0')
      }
      return prefix + text + suffix
    }

    function step(now) {
      if (start === null) start = now
      const p = Math.min(1, (now - start) / DURATION)
      const eased = 1 - Math.pow(1 - p, 3)
      el.textContent = format(Math.round(target * eased))
      if (p < 1) window.requestAnimationFrame(step)
    }

    el.textContent = format(0)
    window.requestAnimationFrame(step)
  }

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return
        animate(entry.target)
        observer.unobserve(entry.target)
      })
    },
    { threshold: 0.4 }
  )

  counters.forEach(function (el) {
    observer.observe(el)
  })
})()

// Blog category bar slider
;(function () {
  const nav = document.querySelector('.blog-nav')
  if (!nav || typeof Swiper === 'undefined') return

  const swiperEl = nav.querySelector('.blog-nav__swiper')
  const prevBtn = nav.querySelector('.blog-nav__arrow--prev')
  const nextBtn = nav.querySelector('.blog-nav__arrow--next')

  const swiper = new Swiper(swiperEl, {
    slidesPerView: 1.6,
    spaceBetween: 15,
    watchOverflow: true,
    breakpoints: {
      480: { slidesPerView: 2.4, spaceBetween: 16 },
      768: { slidesPerView: 4.4, spaceBetween: 20 },
      1024: { slidesPerView: 7, spaceBetween: 24 }
    }
  })

  function syncArrows() {
    if (prevBtn) prevBtn.disabled = swiper.isBeginning
    if (nextBtn) nextBtn.disabled = swiper.isEnd
  }

  swiper.on('slideChange', syncArrows)
  swiper.on('reachBeginning', syncArrows)
  swiper.on('reachEnd', syncArrows)
  syncArrows()

  if (prevBtn) prevBtn.addEventListener('click', () => swiper.slidePrev())
  if (nextBtn) nextBtn.addEventListener('click', () => swiper.slideNext())
})()

// Custom file input - show the chosen file name on the styled pill
;(function () {
  const fields = document.querySelectorAll('[data-file-field]')
  if (!fields.length) return

  fields.forEach(function (field) {
    const input = field.querySelector('input[type="file"]')
    const nameEl = field.querySelector('[data-file-name]')
    if (!input || !nameEl) return

    const placeholder = nameEl.textContent

    function render() {
      nameEl.textContent = input.files && input.files.length
        ? input.files[0].name
        : placeholder
    }

    input.addEventListener('change', render)

    const form = input.closest('form')
    if (!form) return

    // Contact Form 7 resets the form once the mail is sent, which empties the
    // native input - the pill has to drop the file name along with it.
    form.addEventListener('reset', function () {
      window.setTimeout(render, 0)
    })

    form.addEventListener('wpcf7mailsent', function () {
      input.value = ''
      render()
    })
  })
})()

// Lightbox + gallery navigation
;(function () {
  const lightbox = document.querySelector('.lightbox')
  if (!lightbox) return

  const triggers = document.querySelectorAll('[data-lightbox-trigger]')
  const closeButtons = document.querySelectorAll('[data-lightbox-close]')
  const prevButton = document.querySelector('[data-lightbox-prev]')
  const nextButton = document.querySelector('[data-lightbox-next]')
  const lightboxImage = document.querySelector('[data-lightbox-image]')
  const lightboxVideo = document.querySelector('[data-lightbox-video]')
  const lightboxVideoSource = document.querySelector('[data-lightbox-video-source]')
  const lightboxCaption = document.querySelector('[data-lightbox-caption]')
  const currentCounter = document.querySelector('[data-lightbox-current]')
  const imagesDataScript = document.querySelector('[data-lightbox-images]')

  // Product gallery: main swiper + vertical thumbnails + inner zoom
  var mainEl = document.querySelector('[data-gallery-main]')
  var thumbsEl = document.querySelector('[data-gallery-thumbs]')
  var galleryPrevBtn = document.querySelector('[data-gallery-prev]')
  var galleryNextBtn = document.querySelector('[data-gallery-next]')
  var thumbsPrevBtn = document.querySelector('[data-thumbs-prev]')
  var thumbsNextBtn = document.querySelector('[data-thumbs-next]')
  var fullscreenBtn = document.querySelector('[data-gallery-fullscreen]')
  var mainSwiper = null

  if (mainEl && typeof Swiper !== 'undefined') {
    var thumbsSwiper = null
    if (thumbsEl) {
      thumbsSwiper = new Swiper(thumbsEl, {
        direction: 'vertical',
        slidesPerView: 'auto',
        spaceBetween: 12,
        watchSlidesProgress: true
      })
    }

    mainSwiper = new Swiper(mainEl, {
      slidesPerView: 1,
      speed: 400,
      simulateTouch: false,
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined
    })

    if (galleryPrevBtn) {
      galleryPrevBtn.addEventListener('click', function () {
        mainSwiper.slidePrev()
      })
    }
    if (galleryNextBtn) {
      galleryNextBtn.addEventListener('click', function () {
        mainSwiper.slideNext()
      })
    }
    if (thumbsPrevBtn && thumbsSwiper) {
      thumbsPrevBtn.addEventListener('click', function () {
        thumbsSwiper.slidePrev()
      })
    }
    if (thumbsNextBtn && thumbsSwiper) {
      thumbsNextBtn.addEventListener('click', function () {
        thumbsSwiper.slideNext()
      })
    }
  }

  // Inner zoom on hover (desktop / fine pointer only)
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.querySelectorAll('.product-gallery__media').forEach(function (media) {
      var zoomImg = media.querySelector('[data-zoom-img]')
      if (!zoomImg) return

      media.addEventListener('mouseenter', function () {
        media.classList.add('is-zooming')
      })
      media.addEventListener('mousemove', function (e) {
        var rect = media.getBoundingClientRect()
        var x = ((e.clientX - rect.left) / rect.width) * 100
        var y = ((e.clientY - rect.top) / rect.height) * 100
        zoomImg.style.transformOrigin = x + '% ' + y + '%'
      })
      media.addEventListener('mouseleave', function () {
        media.classList.remove('is-zooming')
        zoomImg.style.transformOrigin = 'center center'
      })
    })
  }

  if (!imagesDataScript) return

  var images = []
  try {
    images = JSON.parse(imagesDataScript.textContent)
  } catch (e) {
    console.error('Failed to parse lightbox images data')
    return
  }

  images = images.map(function (img) {
    return Object.assign({}, img, { type: img.type || 'image' })
  })

  var currentIndex = 0
  var lastFocusedElement = null
  var focusableElements = 'button:not([disabled])'

  // Lightbox functions
  function openLightbox(index) {
    lastFocusedElement = document.activeElement
    currentIndex = index
    updateImage()
    lightbox.setAttribute('aria-hidden', 'false')
    document.body.style.overflow = 'hidden'

    setTimeout(function () {
      var firstFocusable = lightbox.querySelector(focusableElements)
      if (firstFocusable) firstFocusable.focus()
    }, 100)
  }

  function closeLightbox() {
    if (lightboxVideo) lightboxVideo.pause()
    lightbox.setAttribute('aria-hidden', 'true')
    document.body.style.overflow = ''

    if (lastFocusedElement) {
      lastFocusedElement.focus()
    }
  }

  function updateImage() {
    var item = images[currentIndex]
    if (!item) return

    if (item.type === 'video' && lightboxVideo && lightboxVideoSource) {
      lightboxImage.style.display = 'none'
      lightboxVideo.style.display = 'block'
      lightboxVideoSource.src = item.src
      lightboxVideo.load()
      lightboxVideo.play().catch(function () {})
      lightboxImage.src = ''
      lightboxImage.alt = ''
    } else {
      if (lightboxVideo) {
        lightboxVideo.style.display = 'none'
        lightboxVideo.pause()
      }
      lightboxImage.style.display = 'block'
      lightboxImage.src = item.src
      lightboxImage.alt = item.alt
    }

    lightboxCaption.textContent = item.alt
    if (currentCounter) {
      currentCounter.textContent = currentIndex + 1
    }
  }

  function showPrev() {
    currentIndex = currentIndex > 0 ? currentIndex - 1 : images.length - 1
    updateImage()
  }

  function showNext() {
    currentIndex = currentIndex < images.length - 1 ? currentIndex + 1 : 0
    updateImage()
  }

  function handleKeydown(e) {
    if (lightbox.getAttribute('aria-hidden') === 'true') return

    switch (e.key) {
      case 'Escape':
        closeLightbox()
        break
      case 'ArrowLeft':
        showPrev()
        break
      case 'ArrowRight':
        showNext()
        break
      case 'Tab':
        trapFocus(e)
        break
    }
  }

  function trapFocus(e) {
    var focusableContent = lightbox.querySelectorAll(focusableElements)
    var firstFocusable = focusableContent[0]
    var lastFocusable = focusableContent[focusableContent.length - 1]

    if (e.shiftKey) {
      if (document.activeElement === firstFocusable) {
        e.preventDefault()
        lastFocusable.focus()
      }
    } else {
      if (document.activeElement === lastFocusable) {
        e.preventDefault()
        firstFocusable.focus()
      }
    }
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var index = parseInt(trigger.dataset.index, 10)
      openLightbox(index)
    })
  })

  if (fullscreenBtn) {
    fullscreenBtn.addEventListener('click', function () {
      openLightbox(mainSwiper ? mainSwiper.activeIndex : 0)
    })
  }

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeLightbox)
  })

  if (prevButton) {
    prevButton.addEventListener('click', showPrev)
  }

  if (nextButton) {
    nextButton.addEventListener('click', showNext)
  }

  document.addEventListener('keydown', handleKeydown)
})()

// FAQ accordion
;(function () {
  var roots = document.querySelectorAll('[data-faq]')
  if (!roots.length) return

  roots.forEach(function (root) {
    var toggles = root.querySelectorAll('[data-faq-toggle]')

    function closeItem(item) {
      item.classList.remove('is-open')
      var answer = item.querySelector('[data-faq-answer]')
      if (answer) answer.style.maxHeight = null
      var toggle = item.querySelector('[data-faq-toggle]')
      if (toggle) toggle.setAttribute('aria-expanded', 'false')
    }

    function openItem(item) {
      item.classList.add('is-open')
      var answer = item.querySelector('[data-faq-answer]')
      if (answer) answer.style.maxHeight = answer.scrollHeight + 'px'
      var toggle = item.querySelector('[data-faq-toggle]')
      if (toggle) toggle.setAttribute('aria-expanded', 'true')
    }

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-faq-item]')
        if (!item) return
        var isOpen = item.classList.contains('is-open')

        root.querySelectorAll('[data-faq-item].is-open').forEach(function (other) {
          if (other !== item) closeItem(other)
        })

        if (isOpen) {
          closeItem(item)
        } else {
          openItem(item)
        }
      })
    })

    // Initialise any item rendered open by default
    root.querySelectorAll('[data-faq-item].is-open').forEach(function (item) {
      openItem(item)
    })
  })
})()

// Sidebar nav toggle (mobile)
;(function () {
  const toggle = document.querySelector('.sidebar-content-layout__toggle')
  if (!toggle) return

  const nav = document.getElementById('sidebar-nav')
  if (!nav) return

  toggle.addEventListener('click', function () {
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true'
    toggle.setAttribute('aria-expanded', !isExpanded)
    nav.classList.toggle('is-open')
  })
})()

// Sidebar sub-menu toggle
;(function () {
  const toggles = document.querySelectorAll('.sidebar-content-layout__submenu-toggle')
  if (!toggles.length) return

  toggles.forEach(function (toggle) {
    const subList = toggle.nextElementSibling
    if (!subList) return

    toggle.addEventListener('click', function () {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true'
      toggle.setAttribute('aria-expanded', !isExpanded)
      subList.classList.toggle('is-open')
    })
  })
})()

// Back to list functionality
;(function () {
  const backLink = document.querySelector('.single-news__back-link')
  if (!backLink) return

  const fallbackUrl = backLink.dataset.fallback
  const referrer = document.referrer

  // Check if user came from the same site
  const isFromSameSite =
    referrer && new URL(referrer).hostname === window.location.hostname

  backLink.addEventListener('click', function (e) {
    e.preventDefault()

    if (isFromSameSite) {
      history.back()
    } else {
      window.location.href = fallbackUrl
    }
  })
})()

// Product listing filters
;(function () {
  const productListing = document.querySelector('.product-listing')
  if (!productListing) return

  const baseUrl = productListing.dataset.baseUrl
  if (!baseUrl) return

  const markaSelect = document.getElementById('filter-marka')
  const sortSelect = document.getElementById('filter-sortuj')

  function applyFilters() {
    const params = new URLSearchParams()

    if (markaSelect && markaSelect.value) {
      params.set('marka', markaSelect.value)
    }
    if (sortSelect && sortSelect.value) {
      params.set('sortuj', sortSelect.value)
    }

    let url = baseUrl
    if (params.toString()) {
      url += '?' + params.toString()
    }

    window.location.href = url
  }

  if (markaSelect) {
    markaSelect.addEventListener('change', applyFilters)
  }
  if (sortSelect) {
    sortSelect.addEventListener('change', applyFilters)
  }
})()

// Product listing view toggle
;(function () {
  const viewButtons = document.querySelectorAll('.product-listing__view-btn')
  if (!viewButtons.length) return

  const gridContainer = document.querySelector('[data-view-container="grid"]')
  const listContainer = document.querySelector('[data-view-container="list"]')

  if (!gridContainer || !listContainer) return

  const STORAGE_KEY = 'product-listing-view'

  function setView(view) {
    viewButtons.forEach((btn) => {
      const isActive = btn.dataset.view === view
      btn.classList.toggle('is-active', isActive)
      btn.setAttribute('aria-pressed', isActive)
    })

    if (view === 'list') {
      gridContainer.hidden = true
      listContainer.hidden = false
    } else {
      gridContainer.hidden = false
      listContainer.hidden = true
    }

    try {
      localStorage.setItem(STORAGE_KEY, view)
    } catch (e) {
      // localStorage not available
    }
  }

  // Restore saved view preference
  try {
    const savedView = localStorage.getItem(STORAGE_KEY)
    if (savedView === 'list' || savedView === 'grid') {
      setView(savedView)
    }
  } catch (e) {
    // localStorage not available
  }

  viewButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const view = btn.dataset.view
      setView(view)
    })
  })
})()

// Sales reps map filtering
;(function () {
  const mapWrapper = document.querySelector('.sales-reps-map__map-wrapper')
  const select = document.getElementById('voivodeship-select')
  const repItems = document.querySelectorAll('.sales-reps-map__rep-item')

  if (!repItems.length) return

  let activeVoivodeship = null

  function filterReps(voivodeship) {
    activeVoivodeship = voivodeship

    repItems.forEach((item) => {
      if (!voivodeship) {
        item.classList.remove('hidden')
        return
      }

      const itemVoivodeships = item.dataset.voivodeships || ''
      const voivodeshipArray = itemVoivodeships.split(',')

      if (voivodeshipArray.includes(voivodeship)) {
        item.classList.remove('hidden')
      } else {
        item.classList.add('hidden')
      }
    })

    // Update map active state
    if (mapWrapper) {
      const paths = mapWrapper.querySelectorAll('path[id]')
      paths.forEach((path) => {
        path.classList.toggle('active', path.id === voivodeship)
      })
    }

    // Update select
    if (select) {
      select.value = voivodeship || ''
    }
  }

  // Map click handler
  if (mapWrapper) {
    mapWrapper.addEventListener('click', (e) => {
      const path = e.target.closest('path[id]')
      if (!path) return

      const voivodeship = path.id

      // Toggle off if clicking same voivodeship
      if (voivodeship === activeVoivodeship) {
        filterReps(null)
      } else {
        filterReps(voivodeship)
      }
    })
  }

  // Select change handler
  if (select) {
    select.addEventListener('change', () => {
      filterReps(select.value || null)
    })
  }
})()

// Dealer locator map palette: desaturated greyscale land with water as the
// only chromatic element, no POI clutter - the look of the reference locator
// the design was based on.
const SHOPS_MAP_STYLES = [
  { elementType: 'geometry', stylers: [{ color: '#fafafa' }] },
  { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#303030' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#fafafa' }] },
  {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#2a2a2a' }, { weight: 1 }]
  },
  {
    featureType: 'administrative.country',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#1f1f1f' }, { weight: 1.4 }]
  },
  {
    featureType: 'administrative.province',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#c9c9c9' }]
  },
  {
    featureType: 'administrative.neighborhood',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#595959' }]
  },
  {
    featureType: 'administrative.land_parcel',
    stylers: [{ visibility: 'off' }]
  },
  {
    featureType: 'landscape',
    elementType: 'geometry',
    stylers: [{ color: '#fafafa' }]
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry.fill',
    stylers: [{ color: '#f9f0df' }]
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#e8e0d2' }]
  },
  { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [{ color: '#f9f0df' }]
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{ color: '#f2fff8' }]
  },
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }]
  },
  {
    featureType: 'road',
    elementType: 'geometry.fill',
    stylers: [{ color: '#ffffff' }]
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#cfd2d5' }]
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#484848' }]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [{ color: '#d8e0e6' }]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#c7d0d8' }]
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry.fill',
    stylers: [{ color: '#e6e8ea' }]
  },
  {
    featureType: 'road.local',
    elementType: 'geometry.fill',
    stylers: [{ color: '#fdfdfd' }]
  },
  {
    featureType: 'transit',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }]
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [{ color: '#e3e3e3' }]
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{ color: '#9badcb' }]
  },
  {
    featureType: 'water',
    elementType: 'labels.text',
    stylers: [{ visibility: 'off' }]
  }
]

const SHOPS_PIN_COLOR = '#e22e31'

function shopsPinIcon() {
  const svg =
    '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="35" viewBox="0 0 28 28">' +
    '<path fill="' +
    SHOPS_PIN_COLOR +
    '" d="M14 0C20 0 26 4 26 12C26 16.5867 23.0416 21.1733 19.9517 24.2523L19.52 24.672C19.376 24.8085 19.232 24.9416 19.0883 25.0712L18.6583 25.449C16.8011 27.0386 15.04 28 14 28C12.96 28 11.1989 27.0386 9.34172 25.449L8.91171 25.0712C5.5344 22.0267 2 17.0133 2 12C2 4 8 0 14 0Z"/>' +
    '<circle cx="14" cy="12" r="4.5" fill="#ffffff"/></svg>'

  return {
    url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
    scaledSize: new google.maps.Size(28, 35),
    anchor: new google.maps.Point(14, 35)
  }
}

function shopsClusterIcon() {
  const svg =
    '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">' +
    '<rect width="30" height="30" rx="8" fill="' +
    SHOPS_PIN_COLOR +
    '"/></svg>'

  return {
    url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
    scaledSize: new google.maps.Size(30, 30),
    anchor: new google.maps.Point(15, 15)
  }
}

// Shops search functionality
async function initShopsSearch() {
  const form = document.getElementById('shops-search-form')
  if (!form) return

  const autocompleteWrapper = document.getElementById(
    'shops-search-autocomplete'
  )
  const latInput = document.getElementById('shops-search-lat')
  const lngInput = document.getElementById('shops-search-lng')
  const radiusSelect = document.getElementById('shops-search-radius')
  const resultsContainer = document.getElementById('shops-search-results')
  const resultsList = document.getElementById('shops-results-list')
  const noResultsContainer = document.getElementById('shops-no-results')
  const mapContainer = document.getElementById('shops-search-map')

  let map = null
  let markers = []
  let clusterer = null
  let infoWindow = null

  // Load Google Maps libraries. Classic google.maps.Marker is used on purpose:
  // AdvancedMarkerElement needs a cloud-configured mapId, and a mapId makes the
  // API ignore the `styles` array that gives the map its design palette.
  const { Map, InfoWindow } = await google.maps.importLibrary('maps')
  await google.maps.importLibrary('marker')
  await google.maps.importLibrary('places')

  // Create error message element
  const errorMessage = document.createElement('p')
  errorMessage.className = 'shops-search__error'
  errorMessage.textContent = 'Proszę wybrać lokalizację z listy podpowiedzi'
  errorMessage.style.display = 'none'

  // Initialize Google Places Autocomplete (new web component)
  if (autocompleteWrapper) {
    const autocomplete = new google.maps.places.PlaceAutocompleteElement({
      includedRegionCodes: ['pl']
    })
    autocomplete.id = 'shops-search-location'
    autocomplete.placeholder = 'Wyszukaj swoją lokalizację lub miasto'
    autocompleteWrapper.appendChild(autocomplete)
    autocompleteWrapper.appendChild(errorMessage)

    // Listen for place selection
    autocomplete.addEventListener('gmp-select', async ({ placePrediction }) => {
      const place = placePrediction.toPlace()
      await place.fetchFields({ fields: ['location'] })
      if (place.location) {
        latInput.value = place.location.lat()
        lngInput.value = place.location.lng()
        errorMessage.style.display = 'none'
      }
    })

    // gmp-place-autocomplete renders into a closed shadow root, so its
    // internals (input padding, the built-in magnifier) cannot be restyled -
    // only the host element is reachable from CSS.
  }

  // Initialize map
  function initMap(centerLat, centerLng) {
    if (!mapContainer) return

    const center = { lat: centerLat, lng: centerLng }

    map = new Map(mapContainer, {
      zoom: 10,
      center: center,
      mapTypeControl: false,
      streetViewControl: false,
      zoomControl: true,
      fullscreenControl: false,
      styles: SHOPS_MAP_STYLES
    })

    infoWindow = new InfoWindow()
  }

  // Clear all markers
  function clearMarkers() {
    if (clusterer) clusterer.clearMarkers()
    markers.forEach((marker) => marker.setMap(null))
    markers = []
  }

  // Create info window content element
  function createInfoContent(item) {
    const div = document.createElement('div')
    div.style.maxWidth = '200px'

    const name = document.createElement('strong')
    name.textContent = item.name
    div.appendChild(name)

    if (item.position) {
      const pos = document.createElement('p')
      pos.style.cssText = 'margin: 5px 0 0; font-size: 12px;'
      pos.textContent = item.position
      div.appendChild(pos)
    }

    if (item.email) {
      const emailP = document.createElement('p')
      emailP.style.cssText = 'margin: 5px 0 0; font-size: 12px;'
      const emailLink = document.createElement('a')
      emailLink.href = 'mailto:' + item.email
      emailLink.textContent = item.email
      emailP.appendChild(emailLink)
      div.appendChild(emailP)
    }

    if (item.phones) {
      const phoneP = document.createElement('p')
      phoneP.style.cssText = 'margin: 5px 0 0; font-size: 12px;'
      phoneP.textContent = 'tel. ' + item.phones
      div.appendChild(phoneP)
    }

    return div
  }

  // Create dealer item element
  function createDealerItem(item) {
    const themeUri = window.shopsSearchConfig.themeUri

    const article = document.createElement('article')
    article.className = 'dealer-item'
    article.dataset.lat = item.lat
    article.dataset.lng = item.lng

    const main = document.createElement('div')
    main.className = 'dealer-item__main'

    const region = document.createElement('p')
    region.className = 'dealer-item__region'
    region.textContent = item.region || item.country || ''
    main.appendChild(region)

    const name = document.createElement('h4')
    name.className = 'dealer-item__name'
    name.textContent = item.name
    main.appendChild(name)

    // Address / e-mail / phone are always visible; opening hours and the
    // website only appear once the card is expanded.
    const details = document.createElement('dl')
    details.className = 'dealer-item__details'

    function addRow(label, value, options) {
      if (!value) return

      const extra = options && options.extra ? ' dealer-item__label--extra' : ''
      const dt = document.createElement('dt')
      dt.className = 'dealer-item__label' + extra
      dt.textContent = label

      const dd = document.createElement('dd')
      dd.className =
        'dealer-item__value' +
        (options && options.extra ? ' dealer-item__value--extra' : '')

      if (options && options.href) {
        const link = document.createElement('a')
        link.href = options.href
        link.textContent = value
        dd.appendChild(link)
      } else if (options && options.multiline) {
        value.split('\n').forEach((line, index) => {
          if (index > 0) dd.appendChild(document.createElement('br'))
          dd.appendChild(document.createTextNode(line))
        })
      } else {
        dd.textContent = value
      }

      details.appendChild(dt)
      details.appendChild(dd)
    }

    addRow('Adres', item.address)
    addRow('Adres e-mail', item.email, { href: 'mailto:' + item.email })
    addRow('Telefon', item.phones)
    addRow('Godziny otwarcia', item.opening_hours, {
      extra: true,
      multiline: true
    })
    addRow('Strona www', item.website, {
      extra: true,
      href: /^https?:\/\//.test(item.website || '')
        ? item.website
        : 'https://' + item.website
    })

    main.appendChild(details)

    article.appendChild(main)

    const hasExtra = Boolean(item.opening_hours || item.website)
    if (hasExtra) {
      const toggle = document.createElement('button')
      toggle.type = 'button'
      toggle.className = 'dealer-item__toggle'
      toggle.setAttribute('aria-expanded', 'false')

      const toggleLabel = document.createElement('span')
      toggleLabel.textContent = 'Rozwiń'

      const toggleIcon = document.createElement('img')
      toggleIcon.src = themeUri + '/assets/images/chevron-down-grey.svg'
      toggleIcon.alt = ''

      toggle.appendChild(toggleLabel)
      toggle.appendChild(toggleIcon)

      toggle.addEventListener('click', (e) => {
        e.stopPropagation()
        const expanded = article.classList.toggle('is-expanded')
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false')
        toggleLabel.textContent = expanded ? 'Zwiń' : 'Rozwiń'
      })

      article.appendChild(toggle)
    }

    const aside = document.createElement('div')
    aside.className = 'dealer-item__aside'

    if (item.emblems && item.emblems.length) {
      const badges = document.createElement('div')
      badges.className = 'dealer-item__badges'
      item.emblems.forEach((emblem) => {
        const badge = document.createElement('div')
        badge.className = 'dealer-item__badge'
        badge.title = emblem.name
        const img = document.createElement('img')
        img.src = emblem.icon
        img.alt = emblem.name
        badge.appendChild(img)
        badges.appendChild(badge)
      })
      aside.appendChild(badges)
    }

    if (item.distance !== undefined) {
      const distance = document.createElement('p')
      distance.className = 'dealer-item__distance'
      distance.textContent = Math.round(item.distance) + ' km'
      aside.appendChild(distance)
    }

    if (item.lat && item.lng) {
      const directions = document.createElement('a')
      directions.className = 'dealer-item__directions'
      directions.href =
        'https://www.google.com/maps/dir/?api=1&destination=' +
        encodeURIComponent(item.lat + ',' + item.lng)
      directions.target = '_blank'
      directions.rel = 'noopener'

      const directionsIcon = document.createElement('img')
      directionsIcon.src = themeUri + '/assets/images/icon-directions.svg'
      directionsIcon.alt = ''

      const directionsLabel = document.createElement('span')
      directionsLabel.textContent = 'Wskazówki dojazdu'

      directions.appendChild(directionsIcon)
      directions.appendChild(directionsLabel)
      aside.appendChild(directions)
    }

    article.appendChild(aside)

    return article
  }

  // Add markers to map
  function addMarkers(results) {
    if (!map) return

    clearMarkers()

    const bounds = new google.maps.LatLngBounds()

    results.forEach((item) => {
      const position = { lat: parseFloat(item.lat), lng: parseFloat(item.lng) }

      const marker = new google.maps.Marker({
        position: position,
        title: item.name,
        icon: shopsPinIcon()
      })

      bounds.extend(position)

      marker.addListener('click', () => {
        infoWindow.setContent(createInfoContent(item))
        infoWindow.open(map, marker)
      })

      markers.push(marker)
    })

    // Group nearby pins into red numbered bubbles, as in the design.
    if (typeof markerClusterer !== 'undefined') {
      if (!clusterer) {
        clusterer = new markerClusterer.MarkerClusterer({
          map: map,
          // Clusters only make sense on the country/region view - from zoom 10
          // up every dealer gets its own pin.
          algorithm: new markerClusterer.SuperClusterAlgorithm({
            radius: 60,
            maxZoom: 9
          }),
          renderer: {
            render: ({ count, position }) =>
              new google.maps.Marker({
                position: position,
                icon: shopsClusterIcon(),
                label: {
                  text: String(count),
                  color: '#ffffff',
                  fontSize: '13px',
                  fontFamily: 'Poppins, sans-serif'
                },
                zIndex: 1000 + count
              })
          }
        })
      }
      clusterer.addMarkers(markers)
    } else {
      markers.forEach((marker) => marker.setMap(map))
    }

    if (results.length > 0) {
      map.fitBounds(bounds)

      // Don't zoom in too much
      google.maps.event.addListenerOnce(map, 'idle', function () {
        if (map.getZoom() > 14) map.setZoom(14)
      })
    }
  }

  // Render results list
  function renderResults(results) {
    resultsList.textContent = ''

    results.forEach((item, index) => {
      const dealerItem = createDealerItem(item)

      dealerItem.addEventListener('click', (e) => {
        // Links and the expand toggle handle their own clicks
        if (e.target.closest('a, button')) return

        const lat = parseFloat(item.lat)
        const lng = parseFloat(item.lng)
        if (map && lat && lng) {
          map.setCenter({ lat, lng })
          map.setZoom(14)

          if (markers[index]) {
            google.maps.event.trigger(markers[index], 'click')
          }
        }
      })

      resultsList.appendChild(dealerItem)
    })
  }

  // Form submission
  form.addEventListener('submit', function (e) {
    e.preventDefault()

    const lat = parseFloat(latInput.value)
    const lng = parseFloat(lngInput.value)
    const radius = radiusSelect.value

    if (!lat || !lng) {
      errorMessage.style.display = 'block'
      return
    }

    errorMessage.style.display = 'none'

    // Initialize map if not already done
    if (!map) {
      initMap(lat, lng)
    }

    // Perform AJAX search
    const formData = new FormData()
    formData.append('action', 'shops_search')
    formData.append('nonce', window.shopsSearchConfig.nonce)
    formData.append('lat', lat)
    formData.append('lng', lng)
    formData.append('radius', radius)

    fetch(window.shopsSearchConfig.ajaxUrl, {
      method: 'POST',
      body: formData
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success && data.data.count > 0) {
          renderResults(data.data.results)
          resultsContainer.style.display = 'block'
          noResultsContainer.style.display = 'none'

          addMarkers(data.data.results)
        } else {
          resultsList.textContent = ''
          resultsContainer.style.display = 'none'
          noResultsContainer.style.display = 'block'
          clearMarkers()
        }
      })
      .catch((error) => {
        console.error('Search error:', error)
        noResultsContainer.style.display = 'block'
        resultsContainer.style.display = 'none'
      })
  })
}

// Make initShopsSearch globally available for Google Maps callback
window.initShopsSearch = initShopsSearch

// Sticky social icons - background color detection
;(function () {
  const container = document.querySelector('[data-sticky-social]')
  if (!container) return

  // Social icons: background color detection
  function getBackgroundColor(element) {
    const style = window.getComputedStyle(element)
    const bg = style.backgroundColor

    const match = bg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/)
    if (match) {
      return {
        r: parseInt(match[1], 10),
        g: parseInt(match[2], 10),
        b: parseInt(match[3], 10),
        a: match[4] !== undefined ? parseFloat(match[4]) : 1
      }
    }
    return null
  }

  function getLuminance(r, g, b) {
    const [rs, gs, bs] = [r, g, b].map((c) => {
      c = c / 255
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)
    })
    return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs
  }

  function blendColors(fg, bg) {
    const a = fg.a
    return {
      r: Math.round(fg.r * a + bg.r * (1 - a)),
      g: Math.round(fg.g * a + bg.g * (1 - a)),
      b: Math.round(fg.b * a + bg.b * (1 - a)),
      a: 1
    }
  }

  function getEffectiveBackgroundAt(x, y) {
    const elements = document.elementsFromPoint(x, y)
    let effectiveColor = { r: 255, g: 255, b: 255, a: 1 }

    for (let i = elements.length - 1; i >= 0; i--) {
      const el = elements[i]

      if (el.closest('[data-sticky-social]')) continue

      const bgColor = getBackgroundColor(el)
      if (bgColor && bgColor.a > 0) {
        effectiveColor = blendColors(bgColor, effectiveColor)
      }

      const style = window.getComputedStyle(el)
      if (style.backgroundImage && style.backgroundImage !== 'none') {
        return { r: 50, g: 50, b: 50, a: 1 }
      }
    }

    return effectiveColor
  }

  function updateIcons() {
    const rect = container.getBoundingClientRect()
    const centerX = rect.left + rect.width / 2
    const centerY = rect.top + rect.height / 2

    container.style.visibility = 'hidden'
    const bgColor = getEffectiveBackgroundAt(centerX, centerY)
    container.style.visibility = ''

    const luminance = getLuminance(bgColor.r, bgColor.g, bgColor.b)

    if (luminance < 0.5) {
      container.classList.add('use-light')
      container.classList.remove('use-dark')
    } else {
      container.classList.add('use-dark')
      container.classList.remove('use-light')
    }
  }

  function throttle(func, limit) {
    let inThrottle
    return function () {
      if (!inThrottle) {
        func.apply(this, arguments)
        inThrottle = true
        setTimeout(() => (inThrottle = false), limit)
      }
    }
  }

  updateIcons()

  const throttledUpdate = throttle(updateIcons, 100)
  window.addEventListener('scroll', throttledUpdate)
  window.addEventListener('resize', throttledUpdate)
})()

// Quick links - background on scroll past intro (homepage)
;(function () {
  const quickLinks = document.querySelector('[data-quick-links]')
  if (!quickLinks) return

  const introSection = document.querySelector('.intro')
  if (!introSection) return

  function updateBackground() {
    if (window.scrollY >= 50) {
      quickLinks.classList.add('has-background')
    } else {
      quickLinks.classList.remove('has-background')
    }
  }

  function throttle(func, limit) {
    let inThrottle
    return function () {
      if (!inThrottle) {
        func.apply(this, arguments)
        inThrottle = true
        setTimeout(() => (inThrottle = false), limit)
      }
    }
  }

  updateBackground()
  const throttledUpdate = throttle(updateBackground, 100)
  window.addEventListener('scroll', throttledUpdate)
})()

// Specs table expand/collapse
;(function () {
  const tables = document.querySelectorAll('.specs-table')
  if (!tables.length) return

  tables.forEach((container) => {
    const table = container.querySelector('.specs-table__table')
    const toggleBtn = container.querySelector('.specs-table__toggle')
    if (!table || !toggleBtn) return

    const visibleRows = parseInt(table.dataset.visibleRows) || 10
    const rows = table.querySelectorAll('tr')
    const toggleText = toggleBtn.querySelector('.specs-table__toggle-text')
    const expandText = toggleBtn.dataset.textExpand || 'Rozwiń więcej'
    const collapseText = toggleBtn.dataset.textCollapse || 'Zwiń'

    // Hide rows beyond visible limit
    rows.forEach((row, index) => {
      if (index >= visibleRows) {
        row.classList.add('is-hidden')
      }
    })

    // Hide button if not needed
    if (rows.length <= visibleRows) {
      toggleBtn.style.display = 'none'
      return
    }

    toggleBtn.addEventListener('click', () => {
      const isExpanded = toggleBtn.classList.toggle('is-expanded')
      rows.forEach((row, index) => {
        if (index >= visibleRows) {
          row.classList.toggle('is-hidden', !isExpanded)
        }
      })
      if (toggleText) {
        toggleText.textContent = isExpanded ? collapseText : expandText
      }
    })
  })
})()

// Product intro highlights expand/collapse
;(function () {
  const expandBtn = document.querySelector('[data-expand-highlights]')
  if (!expandBtn) return

  const highlights = document.querySelectorAll('.product-intro__highlight')
  const expandText = expandBtn.querySelector('[data-expand-text]')

  expandBtn.addEventListener('click', () => {
    const isExpanded = expandBtn.classList.toggle('is-expanded')

    highlights.forEach((item, index) => {
      if (index >= 3) {
        item.classList.toggle('is-hidden', !isExpanded)
      }
    })

    if (expandText) {
      expandText.textContent = isExpanded ? 'Zwiń' : 'Rozwiń więcej'
    }
  })
})()

// Product slider initialization
;(function () {
  const sliders = document.querySelectorAll('.product-slider__swiper')
  if (!sliders.length) return

  sliders.forEach((swiperEl) => {
    const wrapper = swiperEl.closest('.product-slider__wrapper')
    const prevBtn = wrapper.querySelector('.product-slider__nav--prev')
    const nextBtn = wrapper.querySelector('.product-slider__nav--next')

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1.2,
      spaceBetween: 15,
      loop: true,
      breakpoints: {
        480: {
          slidesPerView: 2.3,
          spaceBetween: 15
        },
        768: {
          slidesPerView: 3.3,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20
        },
        1280: {
          slidesPerView: 5,
          spaceBetween: 20
        }
      }
    })

    if (prevBtn) {
      prevBtn.addEventListener('click', () => swiper.slidePrev())
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => swiper.slideNext())
    }
  })
})()

// Product categories - one subcategory slider per category section
;(function () {
  const sliders = document.querySelectorAll('.product-categories__swiper')
  if (!sliders.length || typeof Swiper === 'undefined') return

  sliders.forEach((swiperEl) => {
    const wrapper = swiperEl.closest('.product-categories__slider')
    const prevBtn = wrapper.querySelector('.product-categories__nav--prev')
    const nextBtn = wrapper.querySelector('.product-categories__nav--next')

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1.15,
      spaceBetween: 15,
      watchOverflow: true,
      breakpoints: {
        600: {
          slidesPerView: 2.2,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20
        }
      }
    })

    function syncArrows() {
      if (prevBtn) prevBtn.disabled = swiper.isBeginning
      if (nextBtn) nextBtn.disabled = swiper.isEnd
    }

    if (prevBtn) prevBtn.addEventListener('click', () => swiper.slidePrev())
    if (nextBtn) nextBtn.addEventListener('click', () => swiper.slideNext())

    swiper.on('slideChange', syncArrows)
    swiper.on('resize', syncArrows)
    syncArrows()
  })
})()

// Product video play/pause
;(function () {
  const sections = document.querySelectorAll('.product-video')
  if (!sections.length) return

  sections.forEach((section) => {
    const playBtn = section.querySelector('.product-video__play')
    const video = section.querySelector('.product-video__video')
    const media = section.querySelector('.product-video__media')

    if (!playBtn || !video) return

    function setPlaying() {
      section.classList.add('is-playing')
      section.classList.remove('is-paused')
    }

    function setPaused() {
      section.classList.remove('is-playing')
      section.classList.add('is-paused')
    }

    video.addEventListener('playing', setPlaying)
    video.addEventListener('pause', setPaused)
    video.addEventListener('ended', () => {
      setPaused()
      video.currentTime = 0
    })

    playBtn.addEventListener('click', () => { video.play() })

    video.addEventListener('click', () => {
      if (!video.paused) video.pause()
    })

    media.addEventListener('click', (e) => {
      if (e.target === media || e.target.classList.contains('product-video__cover')) {
        if (video.paused) video.play()
      }
    })

    // Jeśli video ma autoplay — od razu ukryj cover i przycisk
    if (video.autoplay) {
      setPlaying()
    }

    // Dodatkowo spróbuj wymusić play()
    video.play().catch(() => {})
  })
})()

// Product comparison functionality
;(function () {
  const STORAGE_KEY = 'cedrus-compare-products'
  const MAX_PRODUCTS = 3

  // Elements
  const tab = document.querySelector('[data-compare-tab]')
  const modal = document.querySelector('[data-compare-modal]')
  const countDisplay = document.querySelector('[data-compare-count]')
  const productsContainer = document.querySelector('[data-compare-products]')
  const tableHeader = document.querySelector('[data-compare-header]')
  const tableBody = document.querySelector('[data-compare-tbody]')
  const emptyMessage = document.querySelector('[data-compare-empty]')

  if (!tab || !modal) return

  // Get products from storage
  function getProducts() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      return stored ? JSON.parse(stored) : []
    } catch (e) {
      return []
    }
  }

  // Save products to storage
  function saveProducts(products) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(products))
    } catch (e) {
      // localStorage not available
    }
  }

  // Create SVG close icon
  function createCloseIcon(size) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    svg.setAttribute('width', size)
    svg.setAttribute('height', size)
    svg.setAttribute('viewBox', '0 0 24 24')
    svg.setAttribute('fill', 'none')

    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
    path.setAttribute('d', 'M18 6L6 18M6 6L18 18')
    path.setAttribute('stroke', 'currentColor')
    path.setAttribute('stroke-width', '2')
    path.setAttribute('stroke-linecap', 'round')
    path.setAttribute('stroke-linejoin', 'round')

    svg.appendChild(path)
    return svg
  }

  // Show tooltip on button
  function showTooltip(button, message) {
    // Remove any existing tooltip
    const existingTooltip = button.querySelector('.compare-tooltip')
    if (existingTooltip) {
      existingTooltip.remove()
    }

    // Create tooltip element
    const tooltip = document.createElement('span')
    tooltip.className = 'compare-tooltip'
    tooltip.textContent = message
    button.appendChild(tooltip)

    // Show tooltip with slight delay for transition
    requestAnimationFrame(() => {
      tooltip.classList.add('is-visible')
    })

    // Hide and remove tooltip after 3 seconds
    setTimeout(() => {
      tooltip.classList.remove('is-visible')
      setTimeout(() => {
        tooltip.remove()
      }, 200)
    }, 3000)
  }

  // Add product to comparison
  function addProduct(productData, button) {
    const products = getProducts()

    // Check if already exists
    if (products.find((p) => p.id === productData.id)) {
      openModal()
      return
    }

    // Check max limit
    if (products.length >= MAX_PRODUCTS) {
      if (button) {
        showTooltip(button, 'Możesz porównać maksymalnie ' + MAX_PRODUCTS + ' produkty')
      }
      return
    }

    products.push(productData)
    saveProducts(products)
    updateUI()

    // Auto-open modal after 2nd product; otherwise confirm the add on the button
    if (products.length >= 2) {
      openModal()
    } else if (button) {
      showTooltip(button, 'Dodano do porównania')
    }
  }

  // Remove product from comparison
  function removeProduct(productId) {
    let products = getProducts()
    products = products.filter((p) => p.id !== productId)

    saveProducts(products)
    updateUI()
  }

  // Update UI
  function updateUI() {
    const products = getProducts()
    const count = products.length

    // Update count badge (empty when 0 to hide via CSS)
    if (countDisplay) {
      countDisplay.textContent = count > 0 ? count : ''
    }

    // Show/hide tab based on count
    tab.classList.toggle('is-visible', count > 0)

    // Update add buttons state
    document.querySelectorAll('[data-compare-add]').forEach((btn) => {
      const productId = btn.dataset.productId
      const isAdded = products.find((p) => p.id === productId)
      btn.classList.toggle('is-added', !!isAdded)
    })

    // Render comparison content
    renderComparison(products)
  }

  // Render comparison table and products
  function renderComparison(products) {
    if (!productsContainer || !tableHeader || !tableBody) return

    // Clear existing content
    productsContainer.textContent = ''

    // Clear table header (keep first label cell)
    while (tableHeader.children.length > 1) {
      tableHeader.removeChild(tableHeader.lastChild)
    }

    // Clear table body
    tableBody.textContent = ''

    // Show/hide empty message
    if (emptyMessage) {
      emptyMessage.style.display = products.length === 0 ? 'block' : 'none'
    }

    if (products.length === 0) return

    // Render product cards
    products.forEach((product) => {
      const card = document.createElement('div')
      card.className = 'compare-modal__product'

      // Remove button
      const removeBtn = document.createElement('button')
      removeBtn.type = 'button'
      removeBtn.className = 'compare-modal__remove'
      removeBtn.setAttribute('aria-label', 'Usuń z porównania')
      removeBtn.appendChild(createCloseIcon(20))
      removeBtn.addEventListener('click', () => removeProduct(product.id))
      card.appendChild(removeBtn)

      // Image
      if (product.image) {
        const img = document.createElement('img')
        img.src = product.image
        img.alt = ''
        img.className = 'compare-modal__product-image'
        card.appendChild(img)
      } else {
        const placeholder = document.createElement('div')
        placeholder.className =
          'compare-modal__product-image compare-modal__product-image--placeholder'
        card.appendChild(placeholder)
      }

      // Title
      const title = document.createElement('h3')
      title.className = 'compare-modal__product-title'
      title.textContent = product.title
      card.appendChild(title)

      // Price
      const price = document.createElement('p')
      price.className = 'compare-modal__product-price'
      price.textContent = product.price ? product.price + ' zł' : '-'
      card.appendChild(price)

      // Link
      const link = document.createElement('a')
      link.href = product.url
      link.className = 'btn green small compare-modal__product-link'
      link.textContent = 'Zobacz produkt'
      card.appendChild(link)

      productsContainer.appendChild(card)

      // Add header cell
      const th = document.createElement('th')
      th.className = 'compare-modal__product-cell'
      th.textContent = product.title
      tableHeader.appendChild(th)
    })

    // Collect all unique attribute names across products
    const allNames = []
    products.forEach((product) => {
      const attrs = product.attributes || []
      attrs.forEach((attr) => {
        if (!allNames.includes(attr.Name)) {
          allNames.push(attr.Name)
        }
      })
    })

    // Render comparison rows from real attributes
    allNames.forEach((name) => {
      const tr = document.createElement('tr')

      const labelCell = document.createElement('td')
      labelCell.className = 'compare-modal__label-cell'
      labelCell.textContent = name
      tr.appendChild(labelCell)

      products.forEach((product) => {
        const valueCell = document.createElement('td')
        valueCell.className = 'compare-modal__value-cell'
        const attrs = product.attributes || []
        const match = attrs.find((a) => a.Name === name)
        valueCell.textContent = match ? match.Value : '-'
        tr.appendChild(valueCell)
      })

      tableBody.appendChild(tr)
    })
  }

  // Open modal
  function openModal() {
    modal.setAttribute('aria-hidden', 'false')
    document.body.style.overflow = 'hidden'
  }

  // Close modal
  function closeModal() {
    modal.setAttribute('aria-hidden', 'true')
    document.body.style.overflow = ''
  }

  // Event: Add product buttons
  document.addEventListener('click', (e) => {
    const addBtn = e.target.closest('[data-compare-add]')
    if (!addBtn) return

    e.preventDefault()

    let attributes = []
    if (addBtn.dataset.productAttributes) {
      try {
        attributes = JSON.parse(addBtn.dataset.productAttributes)
      } catch (e) {
        attributes = []
      }
    }

    const productData = {
      id: addBtn.dataset.productId,
      title: addBtn.dataset.productTitle,
      image: addBtn.dataset.productImage,
      price: addBtn.dataset.productPrice,
      url: addBtn.dataset.productUrl,
      attributes: attributes
    }

    addProduct(productData, addBtn)
  })

  // Event: Open modal from tab
  document.querySelectorAll('[data-compare-open]').forEach((btn) => {
    btn.addEventListener('click', openModal)
  })

  // Event: Close modal
  document.querySelectorAll('[data-compare-close]').forEach((btn) => {
    btn.addEventListener('click', closeModal)
  })

  // Event: Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
      closeModal()
    }
  })

  // Initialize UI on page load
  updateUI()
})()

// Discover details hotspots
;(function () {
  const section = document.querySelector('.discover-details')
  if (!section) return

  const hotspots = section.querySelectorAll('.discover-details__hotspot')
  const modal = section.querySelector('.discover-details__modal')
  const modalItems = section.querySelectorAll('.discover-details__modal-item')
  const prevBtn = section.querySelector('.discover-details__modal-prev')
  const nextBtn = section.querySelector('.discover-details__modal-next')
  const closeBtn = section.querySelector('.discover-details__modal-close')

  if (!hotspots.length || !modal) return

  let activeIndex = 0
  const totalItems = hotspots.length

  function showDetail(index) {
    // Wrap around
    if (index < 0) index = totalItems - 1
    if (index >= totalItems) index = 0

    activeIndex = index

    // Update hotspots
    hotspots.forEach((h, i) => {
      h.classList.toggle('is-active', i === index)
    })

    // Update modal items
    modalItems.forEach((item, i) => {
      item.classList.toggle('is-active', i === index)
    })

    // Open modal on mobile
    modal.classList.add('is-open')
  }

  function closeModal() {
    modal.classList.remove('is-open')
    hotspots.forEach((h) => h.classList.remove('is-active'))
  }

  // Hotspot hover
  hotspots.forEach((hotspot) => {
    hotspot.addEventListener('mouseenter', () => {
      const index = parseInt(hotspot.dataset.index, 10)
      showDetail(index)
    })
  })

  // Prev/Next buttons
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      showDetail(activeIndex - 1)
    })
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      showDetail(activeIndex + 1)
    })
  }

  // Close button
  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal)
  }

  // Close on escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal()
    }
  })
})()

// Mobile navigation toggle
;(function () {
  const burger = document.querySelector('.burger')
  const mobileNav = document.querySelector('.mobile-nav')

  if (!burger || !mobileNav) return

  function openNav() {
    burger.classList.add('is-active')
    burger.setAttribute('aria-expanded', 'true')
    mobileNav.setAttribute('aria-hidden', 'false')
    document.body.classList.add('mobile-nav-open')
  }

  function closeNav() {
    burger.classList.remove('is-active')
    burger.setAttribute('aria-expanded', 'false')
    mobileNav.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('mobile-nav-open')
  }

  function toggleNav() {
    const isOpen = burger.classList.contains('is-active')
    if (isOpen) {
      closeNav()
    } else {
      openNav()
    }
  }

  burger.addEventListener('click', toggleNav)

  // Close on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && burger.classList.contains('is-active')) {
      closeNav()
    }
  })

  // Close when clicking a link in mobile nav
  mobileNav.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', closeNav)
  })

  // Close on resize if viewport becomes desktop
  window.addEventListener('resize', () => {
    if (window.innerWidth >= 1024 && burger.classList.contains('is-active')) {
      closeNav()
    }
  })
})()

// Site search toggle
;(function () {
  const searchContainer = document.querySelector('.site-search')
  if (!searchContainer) return

  const openBtn = searchContainer.querySelector('.site-search__open')
  const closeBtn = searchContainer.querySelector('.site-search__close')
  const searchInput = searchContainer.querySelector('.site-search__input')

  if (!openBtn || !closeBtn || !searchInput) return

  function openSearch() {
    searchContainer.classList.add('is-open')
    searchInput.focus()
  }

  function closeSearch() {
    searchContainer.classList.remove('is-open')
    searchInput.value = ''
  }

  openBtn.addEventListener('click', openSearch)
  closeBtn.addEventListener('click', closeSearch)

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchContainer.classList.contains('is-open')) {
      closeSearch()
    }
  })
})()

// Desktop mega menu
;(function () {
  const header = document.querySelector('.header')
  const menuItems = document.querySelectorAll('.nav .menu > .menu-item-has-children')
  if (!menuItems.length) return

  let closeTimeout = null
  let currentOpen = null

  function openMegaMenu(item) {
    if (closeTimeout) {
      clearTimeout(closeTimeout)
      closeTimeout = null
    }
    if (currentOpen && currentOpen !== item) {
      currentOpen.classList.remove('mega-menu-open')
      var prevLink = currentOpen.querySelector(':scope > a')
      if (prevLink) prevLink.setAttribute('aria-expanded', 'false')
    }
    item.classList.add('mega-menu-open')
    var link = item.querySelector(':scope > a')
    if (link) link.setAttribute('aria-expanded', 'true')
    currentOpen = item
  }

  function closeMegaMenu() {
    if (currentOpen) {
      var link = currentOpen.querySelector(':scope > a')
      if (link) link.setAttribute('aria-expanded', 'false')
      currentOpen.classList.remove('mega-menu-open')
      currentOpen = null
    }
    if (closeTimeout) {
      clearTimeout(closeTimeout)
      closeTimeout = null
    }
  }

  function scheduleClose() {
    closeTimeout = setTimeout(closeMegaMenu, 300)
  }

  menuItems.forEach(function (item) {
    var link = item.querySelector(':scope > a')
    if (link) {
      link.setAttribute('aria-expanded', 'false')
      link.setAttribute('aria-haspopup', 'true')
    }

    item.addEventListener('mouseenter', function () {
      openMegaMenu(item)
    })

    item.addEventListener('mouseleave', function () {
      scheduleClose()
    })

    if (link) {
      link.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          if (item.classList.contains('mega-menu-open')) {
            closeMegaMenu()
          } else {
            openMegaMenu(item)
          }
        }
      })
    }

    item.addEventListener('focusout', function () {
      setTimeout(function () {
        if (!item.contains(document.activeElement)) {
          closeMegaMenu()
        }
      }, 0)
    })
  })

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && currentOpen) {
      var link = currentOpen.querySelector(':scope > a')
      closeMegaMenu()
      if (link) link.focus()
    }
  })

  window.addEventListener(
    'scroll',
    function () {
      if (currentOpen) {
        closeMegaMenu()
      }
    },
    { passive: true }
  )
})()

// Mobile nav sub-menu toggles
;(function () {
  const mobileNav = document.querySelector('.mobile-nav')
  if (!mobileNav) return

  const parentItems = mobileNav.querySelectorAll('.menu-item-has-children')
  if (!parentItems.length) return

  parentItems.forEach(function (item) {
    const subMenu = item.querySelector(':scope > .sub-menu')
    if (!subMenu) return

    const toggle = document.createElement('button')
    toggle.type = 'button'
    toggle.className = 'mobile-nav__submenu-toggle'
    toggle.setAttribute('aria-expanded', 'false')
    toggle.setAttribute('aria-label', 'Toggle submenu')
    item.insertBefore(toggle, subMenu)

    toggle.addEventListener('click', function () {
      const isOpen = subMenu.classList.contains('is-open')
      subMenu.classList.toggle('is-open')
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true')
    })
  })
})()
